import { render, staticRenderFns } from "./Oldest.vue?vue&type=template&id=23e5369c&lang=pug&"
import script from "./Oldest.vue?vue&type=script&lang=js&"
export * from "./Oldest.vue?vue&type=script&lang=js&"
import style0 from "./Oldest.vue?vue&type=style&index=0&id=23e5369c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports